<template>
  <div v-if="!loading" class="notification-dropdown">
    <div class="close-icon" @click="emitClose">
      <font-awesome-icon icon="times" @click="emitClose" />
    </div>
    <h5>Notifications:</h5>
    <div v-if="!notifications.length">
      <h6>You have no notifications yet</h6>
    </div>
    <div v-for="notification in notifications" :key="notification.id" class="notification">
      <div class="notification__left">
        <div class="dot" :class="{ unread: !notification.isRead }"></div>
      </div>
      <div>
        <p class="notification__right">{{ notification.message }}</p>
      </div>
    </div>
    <div v-if="notifications.length">
      <Pagination
        :hide-pages="true"
        :pagination-details="paginationDetails"
        :show-only-result-count="false"
        @update="loadNotifications($event)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Notification from '@/services/notifications'

import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/utils/pagination'

export default {
  name: 'NotificationsDropdown',
  components: {
    Pagination,
  },
  data() {
    return {
      notifications: [],
      paginationDetails: {},
      loading: true,
    }
  },
  created() {
    this.loadNotifications()
  },
  methods: {
    ...mapActions(['refreshCurrentUser']),
    emitClose() {
      this.$emit('close')
    },
    async loadNotifications(page = null) {
      let filtersWithPageCount = {}
      if (page) {
        filtersWithPageCount = { page: page }
      }
      const response = await Notification.api.list({ filters: filtersWithPageCount })
      this.paginationDetails = getPaginationDataFromResponse(response)
      this.notifications = response.results
      this.loading = false

      await Notification.api.markAllAsRead()

      this.refreshCurrentUser()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.notification-dropdown {
  width: 90%;
  max-width: 500px;
  background-color: #fff;
  position: absolute;
  z-index: 99;
  right: 0;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
}

.notification {
  display: flex;
  border-top: 1px solid #aaa;
  padding: 5px;

  &__left {
    height: 1rem;
  }

  &__right {
    display: inline;
  }
}

.dot {
  height: 0.5rem;
  width: 0.5rem;
  margin: 0.5rem;
}

.unread {
  background-color: rgb(100, 167, 91);
  border-radius: 50%;
  display: inline-block;
}

.close-icon {
  float: right;
  text-align: right;
}
</style>
